<template>
  <div class="flex justify-content-between pt-4 gap-2">
    <div class="flex-grow-1">
      <router-link v-if="prev" :to="prev" class="w-full no-underline">
        <Button
          rounded
          class="previous_button text-sm"
          label="Previous"
          severity="secondary"
          :pt="previousButtonPassThrough"
        />
      </router-link>
    </div>
    <div>
      <router-link v-if="next" :to="next" class="w-full no-underline">
        <Button
          rounded
          class="text-sm border-white w-6rem"
          label="Next"
        />
      </router-link>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  hidden: Boolean
})

const previousButtonPassThrough = {
  root: {
    class: 'border-white',
    style: { backgroundColor: 'rgb(33, 41, 54)' },
  },
}

const route = useRoute()
const parts = route.path.split('/')
const path = ref(parts.slice(1, parts.filter(Boolean).length).join('/'))

const config = useConfigStore()
const { data: navigation } = await useAsyncData(
  `content-${route.fullPath}-nav`,
  () => {
    const cond = Object.keys(config.queries).includes(path.value)
    const baseQuery = queryContent(path.value).only(['_path'])
    const query = cond
      ? baseQuery
          .where(config.queries[path.value].where)
          .sort(config.queries[path.value].sort)
          .findSurround(route.fullPath)
      : baseQuery.findSurround(route.fullPath)
    return query
  }
)

const prev = computed(() => navigation.value?.[0]?._path)
const next = computed(() => navigation.value?.[1]?._path)
</script>

<style lang="scss">
.previous_button:hover {
  background-color: rgb(33, 41, 54) !important; /* Set your desired color */
  border-color: rgb(33, 41, 54) !important;
  color: white !important;
}
</style>
